import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';

const posDef: BnrGpPosModel[] = [];

posDef.push(new BnrGpPosModel({ year: 2025, posId: 2245001, group: 'vss', posText: 'Weiterbildungspfl. BNR (IDD)', planKey: 'idd', einheit: Einheit.minuten }));
posDef.push(
	...[
		new BnrGpPosModel({ year: 2025, posId: 2245041, group: 'eh', posText: 'Baufinanzierung Allianz Leben Bew. (90% Ziel)', planKey: 'baufinanzierungbew', einheit: Einheit.bew }),
		new BnrGpPosModel({ year: 2025, posId: 2245042, group: 'eh', posText: 'Baufinanzierung Allianz Leben Bew. (100% Ziel)', planKey: 'baufinanzierungbew', einheit: Einheit.bew }),
	],
);
posDef.push(
	...[
		new BnrGpPosModel({ year: 2025, posId: 2245043, group: 'eh', posText: 'Bausparen Bew. (90% Ziel)', planKey: 'bausparenbewertung', einheit: Einheit.bew }),
		new BnrGpPosModel({ year: 2025, posId: 2245044, group: 'eh', posText: 'Bausparen Bew. (100% Ziel)', planKey: 'bausparenbewertung', einheit: Einheit.bew }),
	],
);

posDef.push(new BnrGpPosModel({ year: 2025, posId: 2245101, group: 'neh', posText: 'Baufinanzierung Allianz Leben ', planKey: 'baufinanzierungbew', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2245131, group: 'neh', posText: 'Bausparen Bewertung ', planKey: 'bausparenbewertung', einheit: Einheit.bew }));
posDef.push(new BnrGpPosModel({ year: 2025, posId: 2245141, group: 'neh', posText: 'Baufinanzierung Wüstenrot', planKey: 'baufinanzierungwuro', einheit: Einheit.bew }));

export const BbsPositionen = posDef;
